import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
 
Alpine.plugin(collapse)

window.Alpine = Alpine;
window.Alpine.start();
